import React from "react";
import cx from "clsx";
import ClinicDropdown from "./ClinicDropdown";
import { Box } from "../../../../../../shared/Box/Box";
import { useCurrentUserQuery } from "../../../../../../api/queries/useUserQuery";
import { Button } from "../../../../../../shared/Button/Button";
import classes from "../scss/MembershipSavingsReport.module.scss";
import { useDownloadExcel } from "../hooks/useDownloadExcel";
import { CircularProgress } from "../../../../../../shared/CircularProgress/CircularProgress";
import { svg } from "../../../../../../assets/svg";
import { useAppTranslation } from "../../../../../../i18n/useAppTranslation";
import { DateRangePicker } from "../../../../../../shared/DateRangePicker/DateRangePicker";

const Header = ({
  title,
  clinics,
  selectedClinic,
  period,
  requestParams,
  isReportsLoading = false,
}) => {
  const { data: user } = useCurrentUserQuery();
  const { tCommon } = useAppTranslation.Common();

  const { mutate: downloadExcel, isLoading } = useDownloadExcel(requestParams);

  return (
    <Box className={cx("m-b-20 membership-title", classes.headerBox)}>
      <div className="flex items-center gap-8 m-b-5">{title}</div>
      <div className={cx(classes.headerActions)}>
        <ClinicDropdown options={clinics} selectedClinic={selectedClinic} />
        <DateRangePicker
          isDisabled={isReportsLoading}
          size="small"
          dateFormat={user?.dateFormat}
          onChange={({ startDate, endDate }) => {
            period.update({
              fromDate: startDate,
              toDate: endDate,
            });
          }}
          value={{
            startDate: period.value.fromDate,
            endDate: period.value.toDate,
          }}
        />
        <Button
          size="small"
          variant="outlined"
          onClick={downloadExcel}
          isDisabled={isLoading || isReportsLoading}
          leftAdornment={
            isLoading ? (
              <CircularProgress size="small" />
            ) : (
              <img src={svg.downloadPrimary} alt="dl" width="20px" />
            )
          }
        >
          {tCommon("label.downloadExcel")}
        </Button>
      </div>
    </Box>
  );
};

export default Header;
